export default __webpack_public_path__ + "static/media/SERVICES PRO DU RANDONNEUR.fd81e21e.svg";